"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils2 = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(boxPosition, props) {
  var anchorWidth = props.anchorWidth,
    header = props.header;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors,
    direction = _useContext.direction;
  var _useStylesUtils = (0, _useStylesUtils2.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var getBoxPosition = function getBoxPosition() {
    if (boxPosition === 'inline-start') {
      if (direction === 'rtl') {
        return 'right';
      }
      return 'left';
    } else if (boxPosition === 'inline-end') {
      if (direction === 'rtl') {
        return 'left';
      }
      return 'right';
    } else {
      return boxPosition;
    }
  };
  var position = getBoxPosition();
  var ccTooltipStyle = (0, _react.useMemo)(function () {
    var positionProps = function positionProps() {
      switch (position) {
        case 'bottom':
          return {
            paddingTop: pxToRem(13)
          };
        case 'top':
          return {
            paddingBottom: pxToRem(13)
          };
        case 'left':
          return {
            paddingRight: pxToRem(13)
          };
        case 'right':
          return {
            paddingLeft: pxToRem(13)
          };
        default:
          return {};
      }
    };
    var arrowPositionProps = function arrowPositionProps() {
      switch (position) {
        case 'bottom':
          return {
            top: pxToRem(12),
            bottom: 'unset',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(-135deg)',
            backgroundColor: header ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border : themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light
          };
        case 'top':
          return {
            top: 'unset',
            bottom: pxToRem(12),
            left: '50%',
            transform: "translate(-50%, 50%) rotate(45deg)"
          };
        case 'left':
          return {
            top: '50%',
            bottom: 'unset',
            left: "calc(100% - ".concat(pxToRem(12), ")"),
            transform: 'translate(-50%, -50%) rotate(-45deg)'
          };
        case 'right':
          return {
            top: '50%',
            bottom: 'unset',
            left: pxToRem(12),
            transform: 'translate(-50%, -50%) rotate(135deg)'
          };
        default:
          return {};
      }
    };
    var ccTooltip = (0, _css.css)({
      fontFamily: fontFamily,
      display: anchorWidth === 'auto' ? 'block' : 'inline-block',
      position: 'relative',
      userSelect: 'none'
    });
    var ccTooltipHeader = (0, _css.css)({
      overflow: 'hidden',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: pxToRem(6),
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border,
      borderTopLeftRadius: pxToRem(10),
      borderTopRightRadius: pxToRem(10)
    });
    var ccTooltipContent = (0, _css.css)(_objectSpread(_objectSpread({
      position: 'relative',
      fontSize: basicFontSize,
      margin: '0 auto',
      width: 'fit-content'
    }, positionProps()), {}, {
      '&::before': _objectSpread({
        content: '""',
        border: "solid 1px ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border),
        backgroundColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
        borderWidth: '0 1px 1px 0',
        display: 'inline-block',
        padding: pxToRem(4),
        position: 'absolute',
        zIndex: 1
      }, arrowPositionProps())
    }));
    var ccTooltipInnerContent = (0, _css.css)({
      padding: "0 ".concat(pxToRem(4))
    });
    return {
      ccTooltip: ccTooltip,
      ccTooltipHeader: ccTooltipHeader,
      ccTooltipContent: ccTooltipContent,
      ccTooltipInnerContent: ccTooltipInnerContent
    };
  }, [basicFontSize, fontFamily, position, anchorWidth, header, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light]);
  return {
    'cc-Tooltip': ccTooltipStyle.ccTooltip,
    'cc-Tooltip__header': ccTooltipStyle.ccTooltipHeader,
    'cc-Tooltip__content': ccTooltipStyle.ccTooltipContent,
    'cc-Tooltip__inner-content': ccTooltipStyle.ccTooltipInnerContent
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;